import { createTranslationsContext } from '@ori/presentation-translations';
var _createTranslationsCo = createTranslationsContext({
    defaultTranslations: {
      favorites: 'Favorites',
      quickBuy: 'Quick buy'
    }
  }),
  defaultTranslations = _createTranslationsCo.defaultTranslations,
  translationsContext = _createTranslationsCo.translationsContext,
  TranslationsProvider = _createTranslationsCo.TranslationsProvider,
  useTranslations = _createTranslationsCo.useTranslations;
export { defaultTranslations, translationsContext, TranslationsProvider, useTranslations };
//# sourceMappingURL=translationsContext.js.map